import { Box, Paper, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';
import React, { useState } from 'react';

import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';

import FormFieldData from '../../Models/FormFieldData';
import CommonForm from '../../components/form/CommonForm';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
interface ProjectDetailsProps {
  currentRecord: any;
  onSave: () => void;
}
const ProjectDetails: React.FC<ProjectDetailsProps> = ({
  currentRecord,
  onSave,
}) => {
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [customerEmail, setCustomerEmail] = useState<any>(
    currentRecord.customerEmail
  );
  const [customerMainContact, setCustomerMainContact] = useState<any>(
    currentRecord.customerMainContact
  );

  const [loading, setLoading] = useState(false);
  const [projectDialogOpen, setProjectDialogOpen] = useState(false);

  const { getAdmin } = useStore();

  const projectFormFields: FormFieldData[] = [
    {
      name: 'customerEmail',
      label: 'Email',
      value: customerEmail,
      onChange: (e: any) => {
        setCustomerEmail(e.target.value);
      },
      isRequired: true,
      size: 12,
      type: 'textfield',
      validationRules: [(value) => (!value ? 'Email is required' : '')],
    },
    {
      name: 'customerMainContact',
      label: 'Customer Contact',
      value: customerMainContact,
      onChange: (e: any) => {
        setCustomerMainContact(e.target.value);
      },
      isRequired: true,
      size: 12,
      type: 'textfield',
      validationRules: [
        (value) => (!value ? 'Customer Contact is required' : ''),
      ],
    },
  ];

  const clearForm = () => {
    setProjectDialogOpen(false);
    onSave();
  };
  const handleSaveProject = async () => {
    setLoading(true);
    const reqData: any = {
      projectInternalId: currentRecord.projectInternalId,
      customerEmail: customerEmail,
      customerMainContact: customerMainContact,
    };
    const endpoint = `${Constants.apiURL + Constants.projectDashboardsURL}`;
    let response: any;
    try {
      response = await HttpServices.put(endpoint, reqData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });

      if (response.success) {
        clearForm();
      }
    } catch (error: any) {
      console.error(`PUT ERROR:`, error);
      setAlert({
        type: 'error',
        message: error.message,
        open: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const ProjectDialogContent = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <CommonForm
          fields={projectFormFields}
          onCancel={() => {}}
          formReset={clearForm}
          formTitle={'Edit Project'}
          isLoading={loading}
          isUpdate={true}
          onSave={handleSaveProject}
          actionButtonPosition="bottom"
          singlePage={true}
        />
      </Box>
    );
  };

  return (
    <Box sx={{ display: 'grid', gap: '16px' }}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography sx={{ fontWeight: 500 }}>Project details</Typography>
        <Typography
          component={'a'}
          sx={{
            fontWeight: 500,
            fontSize: '14px',
            cursor: 'pointer',
            textDecoration: 'underline',
          }}
          onClick={() => {
            setProjectDialogOpen(true);
          }}
        >
          Edit Project
        </Typography>
      </Box>
      {currentRecord && (
        <Box
          sx={{
            backgroundColor: '#F9F9F9',
            border: '1px solid #EFEEED',
            borderRadius: '6px',
            padding: ' 16px',
          }}
        >
          <Grid container spacing={2}>
            <Grid size={2}>
              <h3 className="ovreview-label">Project Number</h3>
              {currentRecord.projectId}
            </Grid>

            <Grid size={3}>
              <h3 className="ovreview-label">{'Project Name'}</h3>
              {currentRecord.projectName}
            </Grid>
            <Grid size={3}>
              <h3 className="ovreview-label">{'Customer Name'}</h3>
              {currentRecord.customerName}
            </Grid>
            <Grid size={4}>
              <h3 className="ovreview-label">{'Site Address'}</h3>
              {currentRecord.projectSiteAddress}
            </Grid>
          </Grid>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid size={2}>
              <h3 className="ovreview-label">{'Customer Contact'}</h3>
              {currentRecord.customerMainContact}
            </Grid>
            <Grid size={3}>
              <h3 className="ovreview-label">{'Contact Number'}</h3>
              {currentRecord.customerContactNumber}
            </Grid>
            <Grid size={3}>
              <h3 className="ovreview-label">{'Email Address'}</h3>
              {currentRecord.customerEmail}
            </Grid>
          </Grid>
        </Box>
      )}
      <SimpleDialogComponent
        title={''}
        dialogContent={ProjectDialogContent()}
        open={projectDialogOpen}
        handleClose={() => {
          setProjectDialogOpen(false);
        }}
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};

export default ProjectDetails;
